function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M302.253+93.5233L373.952+21.2931L375.367+69.2613L366.045+78.8741L367.502+116.16L357.306+155.485L366.013+159.7L377.8+180.457L385.079+226.451L380.284+257.63L370.278+277.43L372.624+295.985L366.226+329.043L338.093+339.282L353.643+354.849L341.699+384.708L288.167+378.95L278.782+371.912L230.582+386.201L197.309+372.816L197.051+363.137L145.87+387.61L112.684+368.774L117.957+357.056L71.9723+365.03L63.9897+348.831L65.2283+331.083L44.6028+316.677L31.1505+297.516L17.9889+217.401L24.1429+202.374L30.2921+187.359L16.5583+166.186L31.4366+108.961L50.6068+95.5136L32.6462+64.7663L32.6462+50.9892L23.7732+26.7322L92.2194+93.7608L107.82+147.224L108.491+229.411L113.589+236.827L103.444+292.162L111.744+283.998L150.53+288.259L155.994+282.708L197.573+285.36L197.241+293.831L243.586+294.294L241.494+287.527L245.395+284.488L285.528+286.879L300.882+302.314L295.26+243.778L295.475+167.964L298.323+160.531L302.253+93.5233Z",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M328.662+333.009L304.694+305.944",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M253.933+313.606L277.441+362.124",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M198.232+302.756L198.232+350.134",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M93.2186+311.367L85.7643+310.613L74.1562+323.349",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M135.443+324.447L133.445+316.17L104.905+311.604",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M74.9372+237.97L80.3599+226.839",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  d: "M322.954+232.261L316.311+245.936",
  fill: "#ffffff",
  strokeLinecap: "round",
  opacity: 1,
  strokeLinejoin: "round"
});

function SvgForwardA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardA);
export default __webpack_public_path__ + "static/media/forward-a.f8452f2c.svg";
export { ForwardRef as ReactComponent };